(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('terms', {
            parent: 'account',
            url: '/terms',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'terms.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/terms/terms.html',
                    controller: 'TermsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('terms');
                    $translatePartialLoader.addPart('privacy');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
